import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class PromoLineDetail extends BaseEntity {
  
  minimumValue  : number = 1;
  amount        : number = 1;
  repeating     : number = 0;

    constructor() {
      super()
    }
}
